// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitle-format-modal .ant-modal-content {
  width: 420px;
  margin: 0 auto;
  border-radius: 20px;
}
@media only screen and (min-width:576px)  {
  .subtitle-format-modal .ant-modal-body {
    padding-top: 40px;
  }
}
.subtitle-format-modal .ant-modal-body .ant-form-item-label > label {
  display: inline;
}
.subtitle-format-modal .ant-modal-body .ant-radio-group {
  display: flex;
  flex-direction: column;
}
.subtitle-format-modal .ant-btn {
  border-radius: 45px;
  background-color: #f2f2f2;
  color: #333;
  box-shadow: 0px 0.5px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #c9c9c9;
  margin-right: 10px;
  height: auto;
  padding: 5px 15px;
}
.subtitle-format-modal .ant-btn:hover,
.subtitle-format-modal .ant-btn:focus {
  background-color: white;
  border: 1px solid #ffbf6b;
  color: #333;
}
.subtitle-format-modal .ant-btn-primary {
  background-color: #f29f40;
  color: #fff;
  border: none;
  box-shadow: 0px 1.5px 10px rgba(0, 0, 0, 0.2);
}
.subtitle-format-modal .ant-btn-primary:hover,
.subtitle-format-modal .ant-btn-primary:focus {
  background-color: #f3ab58;
  color: #fff;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/TasksList/TaskPanel/DownloadSubtitles/SubtitleModal/style.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAGI;EAAA;IACE,iBAAA;EAAJ;AACF;AATA;EAWM,eAAA;AACN;AAZA;EAcM,aAAA;EACA,sBAAA;AACN;AAhBA;EAmBI,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,6CAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAAJ;AACI;;EACE,uBAAA;EACA,yBAAA;EACA,WAAA;AAEN;AAhCA;EAkCI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;AACJ;AAAI;;EACE,yBAAA;EACA,WAAA;EACA,YAAA;AAGN","sourcesContent":[".subtitle-format-modal {\n  .ant-modal-content {\n    width: 420px;\n    margin: 0 auto;\n    border-radius: 20px;\n  }\n  .ant-modal-body {\n    @media @display-sm {\n      padding-top:40px;\n    }\n    .ant-form-item-label > label {\n      display: inline;\n    }\n    .ant-radio-group {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n  .ant-btn {\n    border-radius: 45px;\n    background-color: #f2f2f2;\n    color: #333;\n    box-shadow: 0px 0.5px 8px rgba(0, 0, 0, 0.15);\n    border: 1px solid rgb(201, 201, 201);\n    margin-right: 10px;\n    height: auto;\n    padding: 5px 15px;\n    &:hover, &:focus {\n      background-color: white;\n      border: 1px solid #ffbf6b;\n      color: #333;\n  }\n  }\n  .ant-btn-primary {\n    background-color: @beey-orange-darken;\n    color: #fff;\n    border: none;\n    box-shadow: 0px 1.5px 10px rgba(0, 0, 0, 0.2);\n    &:hover, &:focus {\n      background-color: @beey-orange;\n      color: #fff;\n      border: none;\n    }\n  }\n}\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
